import * as types from "./types";
import {
    getSalesReport,
    getFinishedGoodReport,
    getSemiReport,
    getRawReport,
    CostAnalysis,
    getProductionReport,
    getLeadTimeReport,
    getLeadTimeConversion,
    getBalanceSheetReportAxios,
    getVatReturnReportAxios,
    getProfitAndLossReportAxios, getTrialBalanceReportAxios, getTdsReportAxios, getCashBookReportAxios, getPayrollVarianceReportAxios, getGeneralLedgerReportAxios,
    getComplaintResolutionTimeReportAxios, getStaffComplaintHandlingPerformanceAxios, getCustomerComplaintFrequencyAxios,
    getLeadClientOpportunityCostSummaryAxios, getCustomerTicketVolumeAnalysisAxios,
    getSalesValueContributionBySalespersonAxios, getLeadAgingAnalysisAxios,
    getSalesSummaryReportAxios, getSalesAnalyticsReportAxios, getSalesAnalyticsReportByProductAxios, getSalesAnalyticsReportByClientAxios, getTicketCategoryReportAxios,
    getQuotationPriorityReportAxios, getProductionCostAnalysisReportAxios, getProductionReportAxios, getProductionLeadTimeAnalysisReportAxios,
    getProjectCostAnalysisReportAxios, getProjectStatusReportAxios,
    getInventoryValueAnalysisReportAxios, getInventoryQtyAnalysisReportAxios, getWarehouseDistributionReportAxios,
    getMonthlySpendingByPlatformAxios
} from "./services";

export async function getSalesReportAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesReport();
        commit(types.GET_SALESREPORT, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}


export async function getFinishedGoodAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getFinishedGoodReport();
        commit(types.GET_FINISHED, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getSemiFinishedGoodAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSemiReport();
        commit(types.GET_SEMI_FINISHED, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}


export async function getRawAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getRawReport();
        commit(types.GET_RAW, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}


export async function getCostAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await CostAnalysis();
        commit(types.GET_COST, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getProductionAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProductionReport();
        commit(types.GET_PRODUCTION, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getLeadTimeAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getLeadTimeReport();
        commit(types.GET_LEADTIME, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getLeadConversionAction({ commit }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getLeadTimeConversion();
        commit(types.GET_LEAD_CONVERSION, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}


export async function getBalanceSheetReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        //         console.log("date", dateFrom);
        // console.log("dates", dateTo);
        const { data } = await getBalanceSheetReportAxios(dateFrom, dateTo);
        commit(types.GET_BALANCESHEET_REPORT, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}


export async function getProfitAndLossReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProfitAndLossReportAxios(dateFrom, dateTo);
        commit(types.GET_PROFIT_AND_LOSS_REPORT, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getTrialBalanceReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getTrialBalanceReportAxios(dateFrom, dateTo);
        commit(types.GET_TRIAL_BALANCE_REPORT, data.result);
    }
    catch (e) {
        console.log(e);
    }
    commit(types.LOADING_REPORT, false);
}

export async function getTdsReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getTdsReportAxios(dateFrom, dateTo);
        commit(types.GET_TDS_REPORT, data.result);
        return data.result;  // Return the response for component handling
    } catch (e) {
        console.error("Error fetching TDS report:", e);
        throw e;  // Ensure errors propagate
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}


export async function getVATReturnReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getVatReturnReportAxios(dateFrom, dateTo);
        commit(types.GET_VATRETURN_REPORT, data.result);
        return data.result;  // Return the response for component handling
    } catch (e) {
        console.error("Error fetching VATReturn report:", e);
        throw e;  // Ensure errors propagate
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getCashBookReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getCashBookReportAxios(dateFrom, dateTo);
        commit(types.GET_CASHBOOK_REPORT, data.result);
        return data.result;  // Return the response for component handling
    } catch (e) {
        console.error("Error fetching CASH BOOK report:", e);
        throw e;  // Ensure errors propagate
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}


export async function getPayrollVarianceReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getPayrollVarianceReportAxios(dateFrom, dateTo);
        commit(types.GET_PAYROLL_VARIANCE_REPORT, data.result);
        return data.result;  // Return the response for component handling
    } catch (e) {
        console.error("Error fetching payroll variance report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getComplaintResolutionTimeReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getComplaintResolutionTimeReportAxios(dateFrom, dateTo);
        commit(types.GET_COMPLAINT_RESOLUTION_TIME_REPORT, data.result);
        return data.result;  // Return the response for component handling
    } catch (e) {
        console.error("Error fetching complaint resolution time report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getStaffComplaintHandlingPerformanceAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getStaffComplaintHandlingPerformanceAxios(dateFrom, dateTo);
        commit(types.GET_STAFF_COMPLAINT_HANDLING_PERFORMANCE, data.result);
        return data.result;  
    } catch (e) {
        console.error("Error fetching staff complaint handling performance report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getCustomerComplaintFrequencyAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getCustomerComplaintFrequencyAxios(dateFrom, dateTo);
        commit(types.GET_CUSTOMER_COMPLAINT_FREQUENCY, data.result);
        return data.result;  
    } catch (e) {
        console.error("Error fetching customer complaint frequency report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getLeadClientOpportunityCostSummaryAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getLeadClientOpportunityCostSummaryAxios(dateFrom, dateTo);
        commit(types.GET_LEAD_CLIENT_OPPORTUNITY_COST_SUMMARY, data.result);
        return data.result;  
    } catch (e) {
        console.error("Error fetching lead client opportunity cost summary report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getCustomerTicketVolumeAnalysisAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getCustomerTicketVolumeAnalysisAxios(dateFrom, dateTo);
        commit(types.GET_CUSTOMER_TICKET_VOLUME_ANALYSIS, data.result);
        return data.result;  
    } catch (e) {
        console.error("Error fetching customer ticket volume analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getGeneralLedgerReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getGeneralLedgerReportAxios(dateFrom, dateTo);
        commit(types.GET_GENERALLEDGER_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching general ledger report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getSalesSummaryReportAction({ commit }, { groupBy, dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesSummaryReportAxios(groupBy, dateFrom, dateTo);
        commit(types.GET_SALES_SUMMARY_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching sales summary report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}


export async function getSalesValueContributionBySalespersonAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesValueContributionBySalespersonAxios(dateFrom, dateTo);
        commit(types.GET_Sales_Value_Contribution_by_Salesperson, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching general ledger report:", e);
        throw e;
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getSalesAnalyticsReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesAnalyticsReportAxios(dateFrom, dateTo);
        commit(types.GET_SALES_ANALYTICS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching sales analytics report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getLeadAgingAnalysisAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getLeadAgingAnalysisAxios(dateFrom, dateTo);
        commit(types.GET_Lead_Aging_Analysis, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching general ledger report:", e);
        throw e;
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getSalesAnalyticsReportByProductAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesAnalyticsReportByProductAxios(dateFrom, dateTo);
        commit(types.GET_SALES_ANALYTICS_REPORT_BY_PRODUCT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching sales analytics report by product:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getSalesAnalyticsReportByClientAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getSalesAnalyticsReportByClientAxios(dateFrom, dateTo);
        commit(types.GET_SALES_ANALYTICS_REPORT_BY_CLIENT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching sales analytics report by client:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getTicketCategoryReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getTicketCategoryReportAxios(dateFrom, dateTo);
        commit(types.GET_TICKET_CATEGORY_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching ticket category report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getQuotationPriorityReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getQuotationPriorityReportAxios(dateFrom, dateTo);
        commit(types.GET_QUOTATION_PRIORITY_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching quotation priority report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getProductionCostAnalysisReportAction({ commit }, { dateFrom, dateTo }) {
    
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProductionCostAnalysisReportAxios(dateFrom, dateTo);
        commit(types.GET_PRODUCTION_COST_ANALYSIS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching production cost analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getProductionReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProductionReportAxios(dateFrom, dateTo);
        commit(types.GET_PRODUCTION_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching production report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getProductionLeadTimeAnalysisReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProductionLeadTimeAnalysisReportAxios(dateFrom, dateTo);
        commit(types.GET_PRODUCTION_LEAD_TIME_ANALYSIS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching production lead time analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getProjectCostAnalysisReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProjectCostAnalysisReportAxios(dateFrom, dateTo);
        commit(types.GET_PROJECT_COST_ANALYSIS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching project cost analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getProjectStatusReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getProjectStatusReportAxios(dateFrom, dateTo);
        commit(types.GET_PROJECT_STATUS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching project status report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getInventoryValueAnalysisReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getInventoryValueAnalysisReportAxios(dateFrom, dateTo);
        commit(types.GET_INVENTORY_VALUE_ANALYSIS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching inventory value analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}
export async function getInventoryQtyAnalysisReportAction({ commit }, { dateFrom, dateTo, itemId }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getInventoryQtyAnalysisReportAxios(dateFrom, dateTo, itemId);
        commit(types.GET_INVENTORY_QTY_ANALYSIS_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching inventory qty analysis report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getWarehouseDistributionReportAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getWarehouseDistributionReportAxios(dateFrom, dateTo);
        commit(types.GET_WAREHOUSE_DISTRIBUTION_REPORT, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching warehouse distribution report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}

export async function getMonthlySpendingByPlatformAction({ commit }, { dateFrom, dateTo }) {
    commit(types.LOADING_REPORT, true);
    try {
        const { data } = await getMonthlySpendingByPlatformAxios(dateFrom, dateTo);
        commit(types.GET_MONTHLY_SPENDING_BY_PLATFORM, data.result);
        return data.result;
    } catch (e) {
        console.error("Error fetching monthly spending by platform report:", e);
        throw e;  
    } finally {
        commit(types.LOADING_REPORT, false);
    }
}